const SITE_ID = 7;const SITE_UID='6aafb62c-b8cc-4419-9948-d7f7c674d9c5';const SUBDOMAIN='jy';export { SITE_ID, SITE_UID, SUBDOMAIN }